// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Fieldborder Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Fieldborder Worker')

  // $FlowFixMe
  const FieldbordersWorker = require('worker-loader?name=[hash].fieldborders.wrkr.js!./worker.js')
  worker = new FieldbordersWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
